import * as React from "react"

import { cn } from "@/lib/utils"

/**
 * Responsive grid variants for different use cases.
 * All variants use mobile-first approach.
 */
const gridVariants = {
  // For agent cards, dashboards, main feature cards (1 → 2 → 3 → 4 cols)
  cards: "grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4",
  // For KPI cards, stats (1 → 2 → 4 cols, skip 3 for symmetry)
  kpis: "grid-cols-1 sm:grid-cols-2 xl:grid-cols-4",
  // For dense lists, small items (2 → 3 → 4 → 6 cols)
  dense: "grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6",
  // For large feature cards (1 → 2 → 3 cols)
  features: "grid-cols-1 md:grid-cols-2 xl:grid-cols-3",
  // For form layouts, settings (1 → 2 cols)
  form: "grid-cols-1 lg:grid-cols-2",
  // Single column always
  single: "grid-cols-1",
} as const

const gapVariants = {
  sm: "gap-3",
  md: "gap-4",
  lg: "gap-6",
  xl: "gap-8",
} as const

export interface CardGridProps extends React.HTMLAttributes<HTMLDivElement> {
  /** Grid column layout variant */
  variant?: keyof typeof gridVariants
  /** Gap size between items */
  gap?: keyof typeof gapVariants
}

export function CardGrid({
  className,
  variant = "cards",
  gap = "md",
  ...props
}: CardGridProps) {
  return (
    <div
      className={cn(
        "grid",
        gridVariants[variant],
        gapVariants[gap],
        className
      )}
      {...props}
    />
  )
}
